
import Vue from "vue";
import { IBreadCrumb } from "winfakt-vue-components";
import AppApiKeys from "@/components/settings-default/ApiKeys.vue";
import AppWfOnlineApiKeys from "@/components/settings-default/WfOnlineApiKeys.vue";

export default Vue.extend({
	computed: {
		path(): IBreadCrumb[] {
			return [
				{
					to: "/settings",
					value: this.$ct("general"),
				},
				{
					value: this.$ct("api-keys"),
				},
			] as IBreadCrumb[];
		},
	},
	components: {
		AppApiKeys,
		AppWfOnlineApiKeys,
	},
	i18nEx: {
		componentPrefix: "components.settings-default",
	},
});
